export default {"src":"/_next/static/media/italic_info_brown.ca44d73f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};